import React from 'react';
import { Overlay, Popover, PopoverContent } from 'react-bootstrap';
import styles from './cartPopover.module.scss';
import './styles.scss';
import { CartProducts } from '.';

const CartPopover = React.forwardRef(({ show, target }, ref) => (
  <Overlay
    show={show}
    target={target}
    placement="bottom"
    container={ref}
    containerPadding={20}
  >
    <Popover id="popover-contained">
      <PopoverContent className={styles.cartPopover}>
        <section className={styles.container}>
          <CartProducts />
        </section>
      </PopoverContent>
    </Popover>
  </Overlay>
));

export default CartPopover;
